import { cn } from "@/lib/utils";

export const StatCard = ({ label, value, hint, icon: Icon, testid, tone, className, style }) => (
  <div
    data-testid={testid}
    style={style}
    className={cn(
      "card-lift fade-up relative overflow-hidden rounded-lg border bg-card p-6",
      tone === "warn" && "border-amber-400/70",
      className,
    )}
  >
    <div className="flex items-start justify-between gap-3">
      <div className="eyebrow">{label}</div>
      {Icon && <Icon className="h-4 w-4 text-[hsl(var(--gold))]" strokeWidth={1.75} />}
    </div>
    <div className="num mt-4 font-display text-3xl font-semibold tracking-tight" data-testid={testid ? `${testid}-value` : undefined}>
      {value}
    </div>
    {hint && <div className="mt-2 text-xs text-muted-foreground">{hint}</div>}
  </div>
);
